import React from 'react'
import { connect } from 'react-redux'
import { localized } from 'decorators'
import { withStyles } from '@material-ui/styles'

import { Form, Row, Col } from 'reactstrap'
import { ValidationBoundary } from 'components/validation'
import { urls } from 'urls'
import { actionCreators } from 'store/modules/orderProcessing'
import { withDialogs } from 'decorators'
import { ValidationResultButton } from 'components/buttons'
import { Page } from 'components/page'
import { fromUrl } from 'utils/fromUrl'
import { LoadingIndicator } from 'components/loading/index'
import { updateEntity } from 'utils/updateEntity'
import { OrderDetails } from './orderDetails'
import { OrderedWines } from './orderedWines'
import { CreateBottlesDetails } from './createBottlesDetail'
import { styles } from './index.css'
import { orderStatus } from 'enums/orderStatus'

export const metadata = {
  icon: 'newspaper-o',
  urls: urls.orderProcessing
}

class OrderProcessingDetail extends React.Component {
  componentDidMount () {
    this.reload()
  }
  reload = () => { this.props.get({ id: fromUrl(this.props) }) }
  updateDeliveredWines = (wines) => updateEntity('deliveredWines', this.props)(wines)

  handleDeliveredUnitsChange = (value, index) => {
    this.updateDeliveredWines(
      this.props.orderProcessing.entity.deliveredWines.map((x, idx) => idx !== index ? x : { ...x, deliveredUnits: value })
    )
  }
  handleActualPriceChange = (value, index) => {
    this.updateDeliveredWines(
      this.props.orderProcessing.entity.deliveredWines.map((x, idx) => idx !== index ? x : { ...x, actualPrice: value })
    )
  }
  handleClick = () => {
    const { entity } = this.props.orderProcessing
    const dto = {
      orderId: entity.id,
      dateOfArrival: entity.dateOfArrival,
      dateOfOrder: entity.dateOfOrder,
      storagePlace: entity.storagePlace,
      storageLocation: entity.storageLocation,
      deliveredWines: entity.deliveredWines,
      supplierId: entity.supplier.id,
      exchangeRate: entity.exchangeRate,
      currencyName: entity.currencyName
    }
    this.props.createBottles(dto, () => this.reload())
  }
  renderContent () {
    const { localize, orderProcessing, classes } = this.props
    const { entity } = orderProcessing
    if (orderProcessing.fetching || entity === null) { return <Row><Col><LoadingIndicator /></Col></Row> }
    
    const disabled = entity.status === orderStatus.created
    return (
      <ValidationBoundary>
        <Form>
          <OrderDetails localize={localize}
            classes={classes}
            entity={entity}
            disabled={disabled}
            onStatusChanged={updateEntity('status', this.props)} />
          <Row><Col><hr /></Col></Row>
          <OrderedWines 
            localize={localize}
            entity={entity}
            classes={classes}
            disabled={disabled}
            onDeliveredUnitsChange={this.handleDeliveredUnitsChange}
            onActualPriceChange={this.handleActualPriceChange}
          />
          <Row><Col><hr /></Col></Row>
          <CreateBottlesDetails
            localize={localize}
            classes={classes}
            entity={entity}
            disabled={disabled}
            onDateOfArrivalChange={updateEntity('dateOfArrival', this.props)}
            onStoragePlaceChange={updateEntity('storagePlace', this.props)}
            onStorageLocationChange={updateEntity('storageLocation', this.props)}
          />
          <Row>
            <Col className={classes.buttonCol}>
              <ValidationResultButton
                onClick={this.handleClick}
                icon='database'
                disabled={orderProcessing.saving || disabled}
                isLoading={orderProcessing.saving}
                buttonTitle='ordersProcessing.createBottles'
                width={250} />
            </Col>
          </Row>
        </Form>
      </ValidationBoundary>
    )
  }
  render () {
    const { localize } = this.props

    return (
      <Page
        metadata={metadata}
        title={localize(`ordersProcessing.detailTitle`)}
        hideGoBack>
          {this.renderContent()}
      </Page>
    )
  }
}
const OrderProcessingDetailPage = withDialogs(withStyles(styles)(connect(
  ({ orderProcessing }) => ({ orderProcessing }),
  {
    get: actionCreators.get,
    update: actionCreators.update,
    createBottles: actionCreators.createBottles
  }
)(localized(OrderProcessingDetail))))

export {
  OrderProcessingDetailPage
}